import App from './App';
import { unregister } from './ServiceWorker';
import ReactDOM from 'react-dom';

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);

unregister();
